(function() {
  var pickerEls = Array.prototype.slice.call(document.querySelectorAll('[data-charm-picker]'));
  if (!pickerEls.length) return;

  var moneyFormat = (typeof theme !== 'undefined' && theme.settings && theme.settings.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  var pickers = pickerEls.map(function(picker) { return setupPicker(picker); });

  // One badge slot after the price block; badges stack in picker order
  var section = pickerEls[0].closest('.product-section');
  if (section) {
    var priceBlock = section.querySelector('.product-block--price');
    var target = priceBlock || section.querySelector('.product-block');
    if (target && target.parentNode) {
      var anchor = target;
      pickers.forEach(function(p) {
        if (!p.badge) return;
        anchor.parentNode.insertBefore(p.badge, anchor.nextSibling);
        p.badge.style.display = '';
        anchor = p.badge;
      });
    }
  }

  function setupPicker(picker) {
    var key = picker.dataset.charmPicker || '';
    var state = {
      el: picker,
      key: key,
      maxPicks: parseInt(picker.dataset.maxPicks) || 2,
      noun: picker.dataset.itemNoun || 'charms',
      bundleTitle: picker.dataset.bundleTitle || 'Sneaker + Free Charms',
      selected: [],
      counter: picker.querySelector('[data-charm-counter]'),
      hint: picker.querySelector('[data-charm-hint]'),
      valueEl: picker.querySelector('[data-charm-value]'),
      badge: document.querySelector('[data-charm-badge="' + key + '"]') || (key ? null : document.querySelector('[data-charm-badge]'))
    };

    if (state.badge) {
      var badgeLink = state.badge.querySelector('[data-charm-badge-link]');
      if (badgeLink) {
        badgeLink.addEventListener('click', function(e) {
          e.preventDefault();
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }

    var scrollEl = picker.querySelector('[data-charm-scroll]');
    var scrollWrap = picker.querySelector('.charm-picker__scroll-wrap');
    var arrowLeft = picker.querySelector('[data-charm-arrow="left"]');
    var arrowRight = picker.querySelector('[data-charm-arrow="right"]');

    function updateArrows() {
      if (!scrollEl || !arrowLeft || !arrowRight) return;
      var atStart = scrollEl.scrollLeft < 4;
      var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 4;
      arrowLeft.classList.toggle('is-visible', !atStart);
      arrowRight.classList.toggle('is-visible', !atEnd);
      if (scrollWrap) scrollWrap.classList.toggle('has-scroll-left', !atStart);
    }
    if (scrollEl) {
      updateArrows();
      scrollEl.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
    }
    if (arrowLeft) arrowLeft.addEventListener('click', function() { scrollEl.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (arrowRight) arrowRight.addEventListener('click', function() { scrollEl.scrollBy({ left: 240, behavior: 'smooth' }); });

    picker.querySelectorAll('.charm-picker__swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function(e) {
        e.stopPropagation();
        var variantId = this.dataset.charmVariantId;
        var price = parseInt(this.dataset.charmPrice) || 0;
        var idx = state.selected.findIndex(function(s) { return s.id === variantId; });
        if (idx > -1) {
          state.selected.splice(idx, 1);
          this.classList.remove('is-selected');
        } else if (state.selected.length < state.maxPicks) {
          state.selected.push({ id: variantId, title: this.dataset.charmTitle, price: price });
          this.classList.add('is-selected');
        } else {
          var oldest = state.selected.shift();
          var oldBtn = picker.querySelector('[data-charm-variant-id="' + oldest.id + '"]');
          if (oldBtn) oldBtn.classList.remove('is-selected');
          state.selected.push({ id: variantId, title: this.dataset.charmTitle, price: price });
          this.classList.add('is-selected');
        }
        updateCounter(state);
      });
    });

    return state;
  }

  function updateCounter(state) {
    var n = state.selected.length;
    if (state.counter) state.counter.textContent = n + ' / ' + state.maxPicks;
    if (state.hint) {
      if (n === state.maxPicks) {
        state.hint.textContent = 'Your ' + state.noun + ' will be added free with your sneaker';
        state.hint.classList.add('charm-picker__hint--ready');
      } else {
        var remaining = state.maxPicks - n;
        state.hint.textContent = 'Select ' + remaining + ' more to add free with your sneaker';
        state.hint.classList.remove('charm-picker__hint--ready');
      }
    }
    if (state.valueEl) {
      if (n > 0) {
        var total = state.selected.reduce(function(sum, s) { return sum + s.price; }, 0);
        state.valueEl.textContent = formatMoney(total) + ' value';
      } else {
        var defaultVal = parseInt(state.valueEl.dataset.defaultValue) || 0;
        state.valueEl.textContent = defaultVal > 0 ? formatMoney(defaultVal) + ' value' : '';
      }
    }
    state.el.classList.toggle('charm-picker--complete', n === state.maxPicks);
  }

  // One form intercept for every picker on the page
  var productForm = section
    ? section.querySelector('form[action*="/cart/add"]')
    : document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  var atcBtn = productForm.querySelector('[type="submit"], [data-add-to-cart]');

  productForm.addEventListener('submit', function(e) {
    var active = pickers.filter(function(p) { return p.selected.length > 0; });
    if (!active.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');

    var sneakerInput = productForm.querySelector('select[name="id"], input[name="id"]');
    var sneakerId = sneakerInput ? sneakerInput.value : null;
    if (!sneakerId) {
      if (atcBtn) atcBtn.removeAttribute('disabled');
      return;
    }

    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart) || '/cart.js';
    var addUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    var changeUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cartChange) || '/cart/change.js';

    var bundleTitle = active.length === 1
      ? active[0].bundleTitle
      : 'Sneaker + Free ' + active.map(function(p) { return capitalise(p.noun); }).join(' + ');

    fetch(cartUrl)
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var standalone = cart.items.find(function(item) {
          return String(item.variant_id) === String(sneakerId) && !item.properties._bundleProduct;
        });
        if (standalone) {
          return fetch(changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: standalone.key, quantity: 0 })
          });
        }
      })
      .then(function() {
        var bundleId = Date.now();
        var props = { _bundleProduct: String(bundleId), _bundleTitle: bundleTitle };
        var items = [{ quantity: 1, id: parseInt(sneakerId), properties: props }];
        active.forEach(function(p) {
          p.selected.forEach(function(item) {
            items.push({ quantity: 1, id: parseInt(item.id), properties: props });
          });
        });
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (atcBtn) atcBtn.removeAttribute('disabled');
        productForm.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { addToCartBtn: atcBtn },
          bubbles: true
        }));
      })
      .catch(function(err) {
        console.error('CharmPicker: cart error', err);
        if (atcBtn) atcBtn.removeAttribute('disabled');
      });
  }, true);

  function capitalise(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
})();
